import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './DynamicArea.css';
import Editor from '../editor/Editor';
import { addDroppedImageToPage } from '../../redux/actions/entities/pages';
import {
  GetActivePage,
  showAlertModal,
  getMaximumImagePerPage,
} from '../../redux/helpers';
import { imageChange } from '../../redux/actions/ui/imageChange';
import { DropLimitReached, disableImageDropByType } from '../../helpers/dropHelper';
import { disableDropCoverType } from '../../helpers/coverHelper';

class DynamicArea extends Component {
  setDebounce() {
    this.setTimeout = clearTimeout(this.setTimeout);
    this.setTimeout = setTimeout(this.stopRendering, 400);
  }

  canDropImage = () => true

  dropImage = (item) => {
    const {
      lang,
      layouts,
      pages,
      isChange,
      backgroundType,
      coverType,
    } = this.props;

    this.setDebounce();
    const activePage = GetActivePage(pages.byId);

    const { isBabyPage } = activePage;
    const maximumPicturesReached = Object.keys(activePage.droppedImages).length === getMaximumImagePerPage(layouts);

    if (disableImageDropByType(activePage)) {
      return true;
    }

    if (activePage.isCover && disableDropCoverType().includes(coverType)) {
      this.props.dispatch(imageChange(false));
      return showAlertModal(lang.title_notice, lang.disable_image_drop_on_this_cover);
    }


    if (DropLimitReached(maximumPicturesReached, isChange, isBabyPage, activePage)) {
      showAlertModal(lang.title_notice, lang.no_more_pictures_on_the_page);
      return true;
    }

    if (backgroundType !== 'tematikus' || !activePage.isCover) {
      this.props.dispatch(addDroppedImageToPage(activePage.id, item.id));
    }

    const coverImages = Object.values((activePage.droppedImages)).length;

    if (backgroundType !== 'tematikus' && (coverImages === 1 || coverImages === 2)) {
      this.props.dispatch(imageChange(false));
    }

    if (isChange && !activePage.isCover) {
      this.props.dispatch(imageChange(false));
    }
  }


  render() {
    const editorProps = {
      height: 'auto',
      width: '100%',
    };

    const {
      isChange,
      placeholders,
      pages,
      lang,
      backgroundPlaceholders,
    } = this.props;
    return (
      <div className="DynamicArea">
        <Editor
          {...editorProps}
          canDropImage={this.canDropImage}
          dropImage={this.dropImage}
          isChange={isChange}
          placeholders={placeholders}
          backgroundPlaceholders={backgroundPlaceholders}
          pages={pages}
          lang={lang}
        />
      </div>
    );
  }
}

DynamicArea.defaultProps = {
  placeholders: {},
  dispatch: () => {},
  lang: {},
  layouts: {},
  isChange: false,
  pages: {},
  coverType: '',
};

DynamicArea.propTypes = {
  placeholders: PropTypes.object,
  dispatch: PropTypes.func,
  lang: PropTypes.object,
  layouts: PropTypes.object,
  isChange: PropTypes.bool,
  pages: PropTypes.object,
  coverType: PropTypes.string,
};

export default connect(state => ({
  placeholders: state.entities.placeholders,
  backgroundPlaceholders: state.entities.backgroundPlaceholders,
  pages: state.entities.pages,
  isChange: state.editorUI.imageChange.isChange,
  layouts: state.entities.layouts.byId,
  backgroundType: state.editorUI.bookProperties.backgroundType,
  coverType: state.bookProperties.cover.type,
}))(DynamicArea);



// WEBPACK FOOTER //
// ./src/components/dynamic-area/DynamicArea.jsx